<template>
  <div :class="blockName" :data-id="id">
    <div :class="element('header')">
      <div :class="element('display-name')">
        <span>{{ translate({ key: "Posted by" }) }} {{ displayName }}</span>
      </div>
      <div>
        <span :class="element('created-at')">
          {{ postedAt }}
        </span>
        <span v-if="hasActiveUser && !flagged">
          <a
            href="#report-post"
            title="Report post as inappropriate."
            :disabled="isReporting"
            @click.prevent="reportComment"
          >
            {{ translate({ key: 'Report' }) }}
          </a>
          <span v-if="isReporting">
            {{ translate({ key: 'Reporting...' }) }}
          </span>
          <span v-if="error" class="text-danger">
            {{ translate({ key: 'Error, try again' }) }}
          </span>
        </span>
      </div>
    </div>
    <div :class="element('body')">
      <p v-if="flagged" :class="element('flagged')">
        {{ translate({ key: 'This comment has been reported.' }) }}
      </p>
      <!-- eslint-disable-next-line -->
      <div v-html="bodyHtml" />
    </div>
  </div>
</template>

<script>
import dayjs from '../dayjs';
import post from '../utils/post';
import FormError from '../errors/form';
import EventEmitter from '../mixins/global-event-emitter';

export default {
  /**
   *
   */
  mixins: [EventEmitter],

  /**
   *
   */
  props: {
    id: {
      type: String,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
    displayName: {
      type: String,
      required: true,
    },
    createdAt: {
      type: Number,
      required: true,
    },
    approved: {
      type: Boolean,
      default: true,
    },
    flagged: {
      type: Boolean,
      default: false,
    },
    dateFormat: {
      type: String,
      default: 'MMM Do, YYYY h:mma',
    },
    activeUser: {
      type: Object,
      default: () => {},
    },
    lang: {
      type: String,
      default: 'en',
    },
  },

  /**
   *
   */
  data: () => ({
    blockName: 'idx-comment-post',
    isReporting: false,
    error: null,
  }),

  /**
   *
   */
  computed: {
    /**
     *
     */
    postedAt() {
      const { createdAt } = this;
      if (!createdAt) return null;
      return dayjs(createdAt).format(this.dateFormat);
    },

    /**
     *
     */
    hasActiveUser() {
      return this.activeUser && this.activeUser.email;
    },

    /**
     *
     */
    bodyHtml() {
      return this.body.replace(/\n/g, '<br>');
    },
  },

  /**
   *
   */
  methods: {
    /**
     *
     */
    element(name) {
      return `${this.blockName}__${name}`;
    },

    async reportComment() {
      if (this.isReporting) return;
      this.error = null;
      this.isReporting = true;
      try {
        const res = await post(`/comment/flag/${this.id}`);
        const data = await res.json();
        if (!res.ok) throw new FormError(data.message, res.status);
        this.emit('comment-report-submitted', { id: this.id });
      } catch (e) {
        this.error = e;
        this.emit('comment-report-errored', { message: e.message, id: this.id });
      } finally {
        this.isReporting = false;
      }
    },

    translate({ key }) {
      const { lang } = this;
      const i18n = {
        pt: {
          'Posted by': 'Publicado por',
          Report: 'Denunciar',
          'Reporting...': 'Denunciando',
          'Error, try again': 'Erro, tente novamente',
          'This comment has been reported.': 'Este comentário foi denunciado.',
        },
        es: {
          'Posted by': 'Publicado por',
          Report: 'Informe',
          'Reporting...': 'Puesto de informes ',
          'Error, try again': 'Error, inténtalo de nuevo ',
          'This comment has been reported.': 'Este comentario ha sido reportado.',
        },
        en: {
          'Posted by': 'Posted by',
          Report: 'Report',
          'Reporting...': 'Reporting...',
          'Error, try again': 'Error, try again',
          'This comment has been reported.': 'This comment has been reported.',
        },
      };
      const value = (i18n[lang] && i18n[lang][key]) ? i18n[lang][key] : i18n.en[key] || key;
      return value;
    },
  },
};
</script>
